<template>
	<App title="Stations">
		<div class="stations-page">

			<div class="stations-hero">
				<div class="stations-hero-icon">
					<i class="fas fa-charging-station"></i>
				</div>
				<div class="stations-hero-body">
					<h4 class="stations-hero-title">Stations</h4>
					<p class="stations-hero-sub">Manage swap stations across the network</p>
				</div>
			</div>

			<div class="stations-table-card">
				<Block>
					<template #header>
						<h3 class="block-title">All Stations</h3>
					</template>
					<Datatable :options="options" />
				</Block>
			</div>

		</div>
	</App>
</template>

<script lang="ts">
import Block from '@/vue/components/Block.vue'
import Datatable from '@/vue/components/Datatable.vue'
import App from '@/vue/templates/App.vue'
import { CellRender, Column } from '@/vue/utils/Datatable'
import { Component, toNative, Vue } from 'vue-facing-decorator'

@Component({
	components: {
		App,
		Block,
		Datatable,
	},
})
class Group extends Vue {
	get buttons() {
		let buttons: any[] = []
		buttons.push('refresh')
		buttons.push({
			extend: 'create',
			attr: {
				href: this.route('station.page.create'),
			},
		})
		buttons.push('trashed')

		return buttons
	}

	get columns() {
		let columns: any[] = []

		columns.push({
			data: 'id',
			orderable: true,
			name: 'id',
			title: 'Id',
		})
		columns.push({
			data: 'title',
			title: 'Title',
			orderable: true,
			name: 'title',
		})
		columns.push({
			data: 'type',
			title: 'Type',
			orderable: true,
			name: 'type',
		})
		// columns.push({
		// 	data: 'zone',
		// 	title: 'Associated Zone',
		// 	orderable: true,
		// 	name: 'zone',
		// })

		columns.push({
			data: 'created_at',
			title: 'Registered',
			render: CellRender.date(),
			orderable: true,
			name: 'created_at',
		})

		columns.push(Column.actions(this.$gate))

		return columns
	}

	get options() {
		return {
			ajax: {
				url: this.route('station.ajax.table'),
				method: 'POST',
			},
			buttons: this.buttons,
			columns: this.columns,
		}
	}
}
export default toNative(Group)
</script>

<style scoped lang="scss">
$primary: #3D5A00;
$primary-light: #f0f4e6;
$border: #e9ecef;
$text-dark: #111827;
$text-light: #6b7280;
$radius: 12px;
$shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
$shadow-hover: 0 4px 14px rgba(0, 0, 0, 0.09);

.stations-page {
	display: flex;
	flex-direction: column;
	gap: 1.25rem;
}

.stations-hero {
	display: flex;
	align-items: center;
	gap: 1.1rem;
	background: #fff;
	border: 1px solid $border;
	border-left: 4px solid $primary;
	padding: 1.25rem 1.5rem;
	box-shadow: $shadow;
}

.stations-hero-icon {
	flex-shrink: 0;
	width: 48px;
	height: 48px;
	border-radius: 10px;
	background: $primary-light;
	color: $primary;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 1.15rem;
}

.stations-hero-title {
	font-size: 1.1rem;
	font-weight: 700;
	color: $text-dark;
	margin: 0 0 0.15rem;
}

.stations-hero-sub {
	font-size: 0.82rem;
	color: $text-light;
	margin: 0;
}

// .stations-table-card {
// 	background: #fff;
// 	border: 1px solid $border;
// 	box-shadow: $shadow;
// 	transition: box-shadow 0.2s;

// 	&:hover { box-shadow: $shadow-hover; }

// 	:deep(.block),
// 	:deep(.block-rounded) {
// 		border-radius: 0 !important;
// 	}
// }
</style>
